module.exports = __webpack_public_path__ + "img/netpay.5a8be0aa.png";